export const GET_ALL_VISIT_REQUESTS_REQUEST = "GET_ALL_VISIT_REQUESTS_REQUEST";
export const GET_ALL_VISIT_REQUESTS_SUCCESS = "GET_ALL_VISIT_REQUESTS_SUCCESS";
export const GET_ALL_VISIT_REQUESTS_FAILURE = "GET_ALL_VISIT_REQUESTS_FAILURE";

export const ADD_VISIT_REQUEST_REQUEST = "ADD_VISIT_REQUEST_REQUEST";
export const ADD_VISIT_REQUEST_SUCCESS = "ADD_VISIT_REQUEST_SUCCESS";
export const ADD_VISIT_REQUEST_FAILURE = "ADD_VISIT_REQUEST_FAILURE";

export const UPDATE_VISIT_REQUEST_REQUEST = "UPDATE_VISIT_REQUEST_REQUEST";
export const UPDATE_VISIT_REQUEST_SUCCESS = "UPDATE_VISIT_REQUEST_SUCCESS";
export const UPDATE_VISIT_REQUEST_FAILURE = "UPDATE_VISIT_REQUEST_FAILURE";

export const GET_VR_BY_ID_REQUEST = "GET_VR_BY_ID_REQUEST";
export const GET_VR_BY_ID_SUCCESS = "GET_VR_BY_ID_SUCCESS";
export const GET_VR_BY_ID_FAILURE = "GET_VR_BY_ID_FAILURE";

export const GET_VR_BY_CP_REQUEST = "GET_VR_BY_CP_REQUEST";
export const GET_VR_BY_CP_SUCCESS = "GET_VR_BY_CP_SUCCESS";
export const GET_VR_BY_CP_FAILURE = "GET_VR_BY_CP_FAILURE";

export const GET_VR_BY_VISITOR_REQUEST = "GET_VR_BY_VISITOR_REQUEST";
export const GET_VR_BY_VISITOR_SUCCESS = "GET_VR_BY_VISITOR_SUCCESS";
export const GET_VR_BY_VISITOR_FAILURE = "GET_VR_BY_VISITOR_FAILURE";

export const UPDATE_VR_STATUS_REQUEST = "UPDATE_VR_STATUS_REQUEST";
export const UPDATE_VR_STATUS_SUCCESS = "UPDATE_VR_STATUS_SUCCESS";
export const UPDATE_VR_STATUS_FAILURE = "UPDATE_VR_STATUS_FAILURE";
